module.exports = __webpack_public_path__ + "img/controlados.25aa7de5.png";